import axios from "axios"
import { del, get, post, put } from "./api_helper"
import * as url from "./url_helper"

import { retrieveValues } from "./storagewrapper.js"

import { isUndefined } from "lodash"

// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = retrieveValues("authUser")
  if (user) return JSON.parse(user)
  return null
}

//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null
}

// Edit profile
const postJwtProfile = data => post(url.POST_EDIT_JWT_PROFILE, data)

// Register Method
const postJwtRegister = (url, data) => {
  return axios
    .post(url, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    })
    .catch(err => {
      var message
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found"
            break
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team"
            break
          case 401:
            message = "Invalid credentials"
            break
          default:
            message = err[1]
            break
        }
      }
      throw message
    })
}

// Login Method
const postJwtLogin = data => post(url.POST_JWT_LOGIN, data, {headers: {"Authorization" : `Bearer ${process.env.REACT_APP_APIKEY}`} })

// postForgetPwd
const postJwtForgetPwd = data => post(url.POST_JWT_PASSWORD_FORGET, data)

// get roles
export const getRoles = (payload) => {
  let _url = url.GET_ROLES + "?";
  if(!isUndefined(payload?.page) && !isUndefined(payload?.size)){
    _url = _url + "&page="+payload.page + "&size=" + payload.size;
  }
  if(!isUndefined(payload?.status)){
    _url = _url + "&status=" + payload.status;
  }
  if(!isUndefined(payload?.countUsers)){
    _url = _url + "&countUsers=" + payload.countUsers;
  }
  return get(_url);
}

// get role details
export const getRolesDetails = id =>
  get(`${url.GET_ROLE_DETAIL}/${id}`, { params: { id } })

/*=== USERS ================================================*/
// get user
export const getUsers = payload => {
  let _url = url.GET_USERS + "?"
  if (!isUndefined(payload?.page) && !isUndefined(payload?.size)) {
    _url = _url + "&page=" + payload.page + "&size=" + payload.size
  }
  if (!isUndefined(payload?.status)) {
    _url = _url + "&status=" + payload.status
  }
  if (!isUndefined(payload?.seasonChangeStatus)) {
    _url = _url + "&seasonChangeStatus=" + payload.seasonChangeStatus
  }
  if (!isUndefined(payload?.search)) {
    _url = _url + "&search=" + payload.search
  }
  if (!isUndefined(payload?.startDate) && payload?.startDate) {
    _url = _url + "&startDate=" + payload.startDate
  }
  if (!isUndefined(payload?.endDate) && payload?.endDate) {
    _url = _url + "&endDate=" + payload.endDate
  }
  return get(_url)
}

export const getUnApprovalCounts = payload => {
  return get(url.GET_USERS + "/unapprove-counts")
}

// Charge user
export const chargeUser = user => put(url.BILLS + "/" + user._id, {billAmount: user.billAmount,seasonChangeValue: user?.seasonChangeValue, billEndDate: user.billEndDate, billStartDate: user.billStartDate})

// get carparks
export const priceBill = payload => {
  let _url = url.BILLS+"/getprice";
  if (payload.unitPrice && payload.billStartDate && payload.billEndDate) {
    _url = _url + "?id="+payload.id+"&price=" + payload.unitPrice + "&billStartDate=" + payload.billStartDate+ "&billEndDate=" + payload.billEndDate
  }
  return get(_url)
}

// add user
export const addNewUser = user => post(url.ADD_NEW_USER, user)

// update user
export const updateUser = user => put(url.UPDATE_USER + "/" + user.id, user)

// delete user
export const deleteUser = user => del(url.DELETE_USER + "/" + user._id)

// BLACKLIST user
export const blacklistUser = user =>
  del(url.DELETE_USER + "/blacklist/" + user._id)

export const getUsersDetails = () => get(url.GET_USER_PROFILE)

export const getExportUsers = payload => {
  let _url = url.GET_USERS + "/data/export"
  // if (!isUndefined(payload?.file_type)) {
  //   _url = _url + "?file_type=" + payload.file_type
  // }
  // if (!isUndefined(payload?.status)) {
  //   _url = _url + "&status=" + payload.status
  // }
  // return get(_url)

  return post(_url, payload)
}

// update User season change status
export const updateUserSeasonChange = user =>
  put(url.UPDATE_SEASON_STATUS + "/" + user.id, user)

/*=== ROLES ================================================*/
// add ROLE
export const addNewRole = role => post(url.ADD_NEW_ROLE, role)

// update role
export const updateRole = role => put(url.UPDATE_ROLE + "/" + role.id, role)

/*=== CARPARK ================================================*/
// get carparks
export const getCarParks = payload => {
  let _url = url.CARPARK
  if (payload.page && payload.size) {
    _url = _url + "?page=" + payload.page + "&size=" + payload.size
  }
  return get(_url)
}

// add carpark
export const addNewCarPark = carpark => post(url.CARPARK, carpark)

// update carpark
export const updateCarPark = carpark =>
  put(url.CARPARK + "/" + carpark.id, carpark)

// delete carpark
export const deleteCarPark = carpark => del(url.CARPARK + "/" + carpark._id)
// details
export const getCarParkDetails = () => get(url.CARPARK)

export const getCarparkOccupancyRate = async (payload) => {
  let _url = url.CARPARK_OCCUPANCY_RATE
  if (payload.page && payload.size) {
    _url = _url + "?page=" + payload.page + "&size=" + payload.size
  }
  if (!isUndefined(payload?.carpark)) {
    _url = _url + "&carpark=" + payload.carpark
  }
  if (!isUndefined(payload?.startDate) && payload?.startDate) {
    _url = _url + "&startDate=" + payload.startDate
  }
  if (!isUndefined(payload?.endDate) && payload?.endDate) {
    _url = _url + "&endDate=" + payload.endDate
  }
  return await get(_url);
}

/*=== SEASON PASS ================================================*/
// get season passes
export const getSeasonPasses = payload => {
  let _url = url.SEASON_PASS + "?"
  if (!isUndefined(payload?.page) && !isUndefined(payload?.size)) {
    _url = _url + "&page=" + payload.page + "&size=" + payload.size
  }
  if (!isUndefined(payload?.status)) {
    _url = _url + "&status=" + payload.status
  }
  if (!isUndefined(payload?.vehicletype)) {
    _url = _url + "&vehicletype=" + payload.vehicletype
  }
  return get(_url)
}

// add SeasonPass
export const addNewSeasonPass = seasonPass => post(url.SEASON_PASS, seasonPass)

// update SeasonPass
export const updateSeasonPass = seasonPass =>
  put(url.SEASON_PASS + "/" + seasonPass.id, seasonPass)

// delete SeasonPass
export const deleteSeasonPass = seasonPass =>
  del(url.SEASON_PASS + "/" + seasonPass._id)
// details
export const getSeasonPassDetails = () => get(url.SEASON_PASS)

/*=== GUEST ================================================*/
// get guest
export const getGuests = payload => {
  let _url = url.GUESTS + "?"
  if (!isUndefined(payload?.page) && !isUndefined(payload?.size)) {
    _url = _url + "&page=" + payload.page + "&size=" + payload.size
  }
  if (!isUndefined(payload?.accessStatus)) {
    _url = _url + "&accessStatus=" + payload.accessStatus
  }
  if(!isUndefined(payload?.status)){
    _url = _url + "&status=" + payload.status;
  }
  if (!isUndefined(payload?.search) && payload?.search) {
    _url = _url + "&search=" + payload.search
  }
  if (!isUndefined(payload?.startDate) && payload?.startDate) {
    _url = _url + "&startDate=" + payload.startDate
  }
  if (!isUndefined(payload?.endDate) && payload?.endDate) {
    _url = _url + "&endDate=" + payload.endDate
  }
  return get(_url)
}

export const guestGrantComplimentary = payload => {
  let _url = '/auth/complimentary/grant';
  if (!isUndefined(payload?.bodyData)) {
    return post(_url, { ...payload?.bodyData })
  }
}

export const guestRequestComplimentary = payload => {
  let _url = url.GUESTS + "/request"
  if (!isUndefined(payload?.bodyData)) {
    return post(_url, { ...payload?.bodyData }).catch(e => {
      console.log(e)
    })
  }
}

// add Guest
export const addNewGuest = Guest => post(url.GUESTS, Guest)

// update Guest
export const updateGuest = Guest => put(url.GUESTS + "/" + Guest.id, Guest)

// update Guest Approve Access
export const updateGuestApproveAccess = Guest =>
  put(url.GUESTS_ACCESS_STATUS + "/" + Guest.id, Guest)

// delete Guest
export const deleteGuest = Guest => del(url.GUESTS + "/entry/" + Guest?._id)

//export guest
export const getExportGuest = payload => {
  let _url = url.GUESTS + "/data/export"
  // if (!isUndefined(payload?.file_type)) {
  //   _url = _url + "?file_type=" + payload.file_type
  // }
  // return get(_url)

  return post(_url, payload)
}

// details
export const getGuestsDetails = () => get(url.GUESTS)

/*=== ADMINS ================================================*/
// get admin
export const getAdmins = payload => {
  let _url = url.ADMINS
  if (payload) {
    _url = _url + "?page=" + payload.page + "&size=" + payload.size
  }
  return get(_url)
}

// add Admin
export const addNewAdmin = admin => post(url.ADMINS, admin)

// update Admin
export const updateAdmin = admin => put(url.ADMINS + "/" + admin.id, admin)

// delete Admin
export const deleteAdmin = admin => del(url.ADMINS + "/" + admin._id)

// details
export const getAdminsDetails = () => get(url.ADMINS)

// change password Admin
export const changePasswordAdmin = admin =>
  post(url.ADMINS + "/change-password/" + admin.id, admin)

/*=== AUDITS ================================================*/
// get audits
export const getAuditTickets = payload => {
  let _url = url.AUDITS + "?"

  if (!isUndefined(payload?.page) && !isUndefined(payload?.size)) {
    _url = _url + "&page=" + payload.page + "&size=" + payload.size
  }
  if (!isUndefined(payload?.module)) {
    _url = _url + "&module=" + payload.module
  }
  if (!isUndefined(payload?.search) && payload?.search) {
    _url = _url + "&search=" + payload.search
  }
  if (!isUndefined(payload?.startDate) && payload?.startDate) {
    _url = _url + "&startDate=" + payload.startDate
  }
  if (!isUndefined(payload?.endDate) && payload?.endDate) {
    _url = _url + "&endDate=" + payload.endDate
  }
  return get(_url)
}

// export audits
export const getExportAuditTickets = payload => {
  let _url = url.AUDITS + "/data/export"
  // if (!isUndefined(payload?.file_type)) {
  //   _url = _url + "?file_type=" + payload.file_type
  // }
  // if (!isUndefined(payload?.auditModuleType)) {
  //   _url = _url + "&auditModuleType=" + payload.auditModuleType
  // }
  // return get(_url)

  return post(_url, payload)
}

//get bills
export const getBills = payload => {
  let _url = url.BILLS + "?"
  if (!isUndefined(payload?.status)) {
    _url = _url + "&status=" + payload.status
  }
  if (!isUndefined(payload?.carpark) && payload?.carpark != null) {
    _url = _url + "&carpark=" + payload.carpark
  }
  if (!isUndefined(payload?.startDate)) {
    _url = _url + "&startDate=" + payload.startDate
  }
  if (!isUndefined(payload?.endDate)) {
    _url = _url + "&endDate=" + payload.endDate
  }
  // if (!isUndefined(payload?.startDate) && !isUndefined(payload?.endDate)) {
  //   _url = _url + "&startDate=" + payload.startDate + "&endDate=" + payload.endDate
  // }
  if (!isUndefined(payload?.page) && !isUndefined(payload?.size)) {
    _url = _url + "&page=" + payload.page + "&size=" + payload.size
  }
  if (!isUndefined(payload?.search) && payload?.search) {
    _url = _url + "&search=" + payload.search
  }
  return get(_url)
}

// add bill
export const addNewBill = bill => post(url.BILLS, bill)

// update bill
export const updateBill = bill => put(url.BILLS + "/update/" + bill.id, bill)

// delete bill
export const deleteBill = bill => del(url.BILLS + "/" + bill._id)

// details
export const getBillDetails = () => get(url.BILLS)

//get bills errors
export const getBillErrors = payload => {
  let _url = url.BILLS + "/bill-errors?"
  if (!isUndefined(payload?.isSuccess)) {
    _url = _url + "&isSuccess=" + payload.isSuccess
  }
  if (!isUndefined(payload?.page) && !isUndefined(payload?.size)) {
    _url = _url + "&page=" + payload.page + "&size=" + payload.size
  }

  return get(_url)
}

//get Formatted bills errors
export const getBillFormattedErrors = async (payload) => {
  let _url = url.BILLS + "/bill-errors/formatted-error?"
  if (!isUndefined(payload?.page) && !isUndefined(payload?.size)) {
    _url = _url + "&page=" + payload.page + "&size=" + payload.size
  }
let data = get(_url);
  return await data;
}

// export bill
export const getExportBills = payload => {
  // if (!isUndefined(payload?.file_type)) {
  //   _url = _url + "?file_type=" + payload.file_type
  // }
  // return get(_url)

  return post(url.BILLS + "/data/export", payload)
}

const updatesettingApi = (settingId, data) => {
  return put(
    url.UPDATE_SYSTEM_SETTING + "/" + settingId.settingId,
    settingId.data
  )
}

const getSettingApi = () => {
  return get(url.GET_SYSTEM_SETTING)
}

const getManageAdminDataApi = () => {
  return get(url.GET_MANAGE_ADMIN)
}

//Carpark/Session list
export const getSessionTickets = payload => {
  let _url = url.CARPARK_TICKETS + "/sessions?"

  if (!isUndefined(payload?.page)) {
    _url = _url + "&page=" + payload.page
  }
  if (!isUndefined(payload?.size)) {
    _url = _url + "&size=" + payload.size
  }
  if (!isUndefined(payload?.role)) {
    _url = _url + "&role=" + payload.role
  }
  if (!isUndefined(payload?.type)) {
    _url = _url + "&type=" + payload.type
  }
  if (!isUndefined(payload?.search)) {
    _url = _url + "&search=" + payload?.search
  }
  if (!isUndefined(payload?.startDate)) {
    _url = _url + "&startDate=" + payload.startDate
  }
  if (!isUndefined(payload?.endDate)) {
    _url = _url + "&endDate=" + payload.endDate
  }  
  if (!isUndefined(payload?.showUserOnly)) {
    _url = _url + "&showUserOnly=" + payload.showUserOnly
  }
  // if (!isUndefined(payload?.startDate) && !isUndefined(payload?.endDate)) {
  //   _url = _url + "&startDate=" + payload.startDate + "&endDate=" + payload.endDate
  // }
  return get(_url)
}

// add SessionTicket
export const addNewSessionTicket = sessionTicket =>
  post(url.CARPARK_TICKETS, sessionTicket)

// update sessionTicket
export const updateSessionTicket = sessionTicket =>
  put(url.CARPARK_TICKETS + "/" + sessionTicket.id, bill)

// delete sessionTicket
export const deleteSessionTicket = sessionTicket =>
  del(url.CARPARK_TICKETS + "/" + sessionTicket._id)

// details
export const getSessionTicketDetails = () => get(url.CARPARK_TICKETS)

export const getExportSessionTickets = payload => {
  let _url = url.CARPARK_TICKETS + "/sessions/export"
  // if (!isUndefined(payload?.file_type)) {
  //   _url = _url + "?file_type=" + payload.file_type
  // }
  // return get(_url)

  return post(_url,payload)
}

export const postLiftUpBarrier = payload =>
  post(url.CARPARK_TICKETS + "/pms/liftupbarrier", payload)

//Special Date
const getSpecialDates = filter => {
  let _url = url.GET_SPECIAL_DATES
  if (filter === undefined) {
    _url = _url
  } else {
    _url = _url + "?year=" + filter.year
  }
  return get(_url)
}
const addSpecialDates = data => post(url.ADD_SPECIAL_DATES, data)
const deleteSpecialDate = specialDateId =>
  del(url.DELETE_SPECIAL_DATES + "/" + specialDateId)
const updateSpecialDate = (specialDateId, data) => {
  return put(url.UPDATE_SPECIAL_DATES + "/" + specialDateId, data)
}

export const getExportSpecialDate = payload => {
  let _url = url.GET_SPECIAL_DATES + "/data/export"
  if (!isUndefined(payload?.file_type)) {
    _url = _url + "?file_type=" + payload.file_type
  }
  return get(_url)
}

// Dashboard
export const getDashboardRevenueReport = payload =>
  get(url.DASHBOARD + "/carpark-revenue", payload)

// Dashboard Occupancy report
export const getDashboardOccupancyReport = payload => {
  let _url = url.DASHBOARD + "/carpark-occupancy-rate"
  return post(_url, {durationType: payload.durationType})
}

export const getExportOccupancyRate = payload => {
  let _url = url.CARPARK+"/export/occupancyrate" 
  
  if (payload?.file_type) {
    _url = _url + "?file_type=" + payload.file_type
  }
  if (!isUndefined(payload?.carpark)) {
    _url = _url + "&carpark=" + payload.carpark
  }
  if (!isUndefined(payload?.startDate) && payload?.startDate) {
    _url = _url + "&startDate=" + payload.startDate
  }
  if (!isUndefined(payload?.endDate) && payload?.endDate) {
    _url = _url + "&endDate=" + payload.endDate
  }
  return get(_url);
}
export const getLotsSoldForDay = () => {
  let _url = url.LOTS_SOLD_URL;
  return get(_url);
}

/*=== BLACKLISTS ================================================*/

// get blacklists
export const getBlacklists = (payload) => {
  let _url = url.GET_BLACKLISTS + "?";
  if(!isUndefined(payload?.page) && !isUndefined(payload?.size)){
    _url = _url + "&page="+payload.page + "&size=" + payload.size;
  }
  if(!isUndefined(payload?.status)){
    _url = _url + "&status=" + payload.status;
  }
  return get(_url);
}

// get blacklist details
export const getBlacklistsDetails = id =>
  get(`${url.GET_BLACKLIST_DETAIL}/${id}`, { params: { id } })

// add BLACKLIST
export const addNewBlacklist = blacklist => post(url.ADD_NEW_BLACKLIST, blacklist)

// update blacklist
export const updateBlacklist = blacklist => put(url.UPDATE_BLACKLIST + "/" + blacklist.id, blacklist)


export {
  getLoggedInUser,
  isUserAuthenticated,
  postJwtRegister,
  postJwtLogin,
  postJwtForgetPwd,
  postJwtProfile,
  updatesettingApi,
  getSettingApi,
  getManageAdminDataApi,
  getSpecialDates,
  addSpecialDates,
  deleteSpecialDate,
  updateSpecialDate,
}
